import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';
import { PrepareTransaction } from '../transaction';
import {
  LaunchTransactionStatus,
  SetQueryParams,
  SetSearchParams,
  SetTokenParam,
} from './query-param.actions';

@Injectable()
export class QueryParamEffects {
  public getServiceOptiosn$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetQueryParams),
      map(({ queryParams, endpoint }) => {
        if (endpoint === 'v3') {
          return SetTokenParam({
            queryParams,
            endpoint,
            isTransactionStatus: false,
          });
        } else {
          return SetSearchParams({ queryParams, endpoint });
        }
      })
    )
  );

  public launchTransactionStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LaunchTransactionStatus),
      map(({ queryParams, endpoint }) => {
        if (endpoint === 'v3') {
          return SetTokenParam({
            queryParams,
            endpoint,
            isTransactionStatus: true,
          });
        } else {
          return SetSearchParams({ queryParams, endpoint });
        }
      })
    )
  );

  constructor(private actions$: Actions) {}
}
